import BotDialogType from '../../core/type/dialog/BotDialogType';
import ButtonInputType from '../../core/type/input/ButtonInputType';
import UserDialogType from '../../core/type/dialog/UserDialogType';
import SelectorInputType from '../../core/type/input/SelectorInputType';
import Interceptor from '../../core/type/operation/Interceptor';
import { sendBotResponse } from './util';
import Switch from '../../core/type/operation/Switch';
import Case from '../../core/type/operation/Case';
import SeletorProjetoInputType from '../../core/type/input/SeletorProjetoInputType';
import TextInputType from '../../core/type/input/TextInputType';
import citiesJson from '../../util/geo/cities.json';
import states from '../../util/geo/states.json';

export default [
  new Interceptor(async (data) => new Promise((resolve) => {
    const cities = citiesJson.map((c) => {
      const state = states.find((s) => s.id === c.state_id);
      return (
        {
          id: c.id,
          value: c.name,
          text: `${c.name}-${state.abbr}`,
          state: state.abbr,
          state_full: state.name,
        }
      );
    });
    resolve({
      ...data,
      options: {
        ...data.options,
        cities,
      },
    });
  })),

  new BotDialogType({
    message: 'Com que frequência você acompanha seus indicadores de marketing e vendas?',
    checkpoint: true,
  }),

  new ButtonInputType({
    key: 'frequency_data',
    buttons: [
      { value: 'ALWAYS_FOLLOW', text: 'Acompanho sempre' },
      { value: 'FOLLOW_LITTLE', text: 'Acompanho pouco' },
      { value: 'DONT_FOLLOW', text: 'Não acompanho' },
    ],
  }),

  new UserDialogType({
    message: '#{frequency_data.text}',
  }),

  new Switch({
    ref: 'frequency_data',
    cases: [
      new Case({
        express: '\'$v\' === \'ALWAYS_FOLLOW\'',
        components: [
          new BotDialogType({
            message: `Que maravilha! Bom saber que você entende a importância do acompanhamento
            de indicadores de marketing e vendas para o crescimento do seu negócio.`,
            checkpoint: true,
          }),
        ],
      }),
      new Case({
        express: '\'$v\' === \'FOLLOW_LITTLE\'',
        components: [
          new BotDialogType({
            message: `Já é um começo. Sabemos que acompanhar os indicadores de marketing e vendas nem sempre é simples,
            mas é muito importante para atingir bons resultados.`,
            checkpoint: true,
          }),
        ],
      }),
      new Case({
        express: '\'$v\' === \'DONT_FOLLOW\'',
        components: [
          new BotDialogType({
            message: `Certo! Nem sempre é fácil dar a devida atenção ao acompanhamento dos indicadores de marketing e vendas.
            Mas não se preocupe, vamos te ajudar a mudar essa realidade.`,
          }),
        ],
      }),
    ],
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, frequency_data: data.frequency_data },
      frequency_data: data.frequency_data.text,
    });
  })),

  new BotDialogType({
    message: 'Em média vocês investiram quanto em anúncios por mês este ano?',
    checkpoint: true,
    tooltip: 'Investimento em anúncios na internet como Google Ads, Facebook Ads e Instagram Ads.',
  }),

  new TextInputType({
    placeholder: '',
    mask: 'currency',
    key: 'ad_investment',
    suggestionsId: 'number_ad_suggestions',
  }),

  new UserDialogType({
    message: '#{ad_investment.maskedValue}',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, ad_investment: data.ad_investment },
      ad_investment: data.ad_investment.raw,
    });
  })),

  new BotDialogType({
    message: '',
    checkpoint: true,
  }),

  new BotDialogType({
    message: 'Selecione as ferramentas e estratégias que sua empresa utiliza para geração de negócios.',
    checkpoint: true,
  }),

  new SelectorInputType({
    key: 'alternatives',
    type: 'checkbox',
    column: 'half',
    options: 'option_alternatives',
  }),

  new BotDialogType({
    message: '',
    checkpoint: true,
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    const values = [...data.alternatives];
    if (values.find((v) => v.value === 'none')) {
      resolve({
        ...data,
        information: { ...data.information, alternatives: data.alternatives },
        alternatives: 'Minha empresa não utiliza nenhuma das alternativas indicadas.',
      });
    } else {
      resolve({
        ...data,
        information: { ...data.information, alternatives: data.alternatives },
        alternatives: `Minha empresa utiliza: ${data.alternatives?.map((obj) => obj.text).join(', ')}`,
      });
    }
  })),

  new UserDialogType({
    message: '#{alternatives}',
  }),

  new BotDialogType({
    message: 'Qual o faturamento médio mensal da sua empresa? Leve em consideração os últimos 6 meses.',
    checkpoint: true,
  }),
  sendBotResponse(),

  new BotDialogType({
    message: 'Não se preocupe, utilizamos essa informação apenas para poder sugerir as soluções ideais para o perfil do seu negócio.',
  }),

  new TextInputType({
    placeholder: '',
    key: 'monthly_income',
    mask: 'currency',
    // suggestionsId: 'segmentOptions',
  }),

  new UserDialogType({
    message: '#{monthly_income.maskedValue}',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, monthly_income: data.monthly_income },
      monthly_income: data.monthly_income.maskedValue,
    });
  })),

  new BotDialogType({
    message: 'Sobre o seu momento, qual dessas opções se encaixa melhor na sua situação:',
    checkpoint: true,
  }),

  new SelectorInputType({
    key: 'project_type',
    type: 'radio',
    column: 'half',
    options: 'option_project_type',
  }),

  new UserDialogType({
    message: '#{project_type.text}',
  }),

  new Switch({
    ref: 'project_type',
    cases: [
      new Case({
        express: '\'$v\' === \'KNOW_WHAT_NEEDS\'',
        components: [
          new BotDialogType({
            message: 'Show! Neste caso, selecione abaixo o perfil de parceiro(s) que você procura',
          }),
          new SelectorInputType({
            key: 'product_project',
            type: 'checkbox',
            column: 'half',
            options: 'option_product_project',
          }),
          new Interceptor(async (data) => new Promise((resolve) => {
            const values = [...data.product_project];
            if (values.find((v) => v.value === 'none')) {
              resolve({
                ...data,
                information: { ...data.information, product_project: data.product_project },
                product_project: 'Não precisamos de nenhuma das alternativas indicadas.',
              });
            } else {
              resolve({
                ...data,
                information: { ...data.information, product_project: data.product_project },
                product_project: `Precisamos de: ${data.product_project?.map((obj) => obj.text).join(', ')}`,
              });
            }
          })),
          new UserDialogType({
            message: '#{product_project}',
          }),
        ],
      }),
      new Case({
        express: '\'$v\' === \'NEED_HELP\'',
        components: [
          new BotDialogType({
            message: 'Ok, pode deixar que a gente vai te ajudar.',
            checkpoint: true,
          }),
        ],
      }),
    ],
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, project_type: data.project_type },
      project_type: data.project_type.text,
    });
  })),

  new BotDialogType({
    message: 'Agora, com base nas opções abaixo, nos informe qual sua expectativa com as soluções que apresentaremos para você.',
  }),

  new SeletorProjetoInputType({
    key: 'project_expectation',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    const selectorMap = (selection) => {
      if (selection === 'quality') {
        return 'alta qualidade';
      } if (selection === 'time') {
        return 'resultado rápido';
      } if (selection === 'price') {
        return 'custo baixo';
      }
      return '';
    };
    const answer = data.project_expectation.map((s) => selectorMap(s)).join(' e ');
    resolve({
      ...data,
      information: { ...data.information, project_expectation: data.project_expectation },
      project_expectation: `Tenho a expectativa de soluções com ${answer}`,
    });
  })),

  new UserDialogType({
    message: '#{project_expectation}.',
  }),

  // new Interceptor(async (data) => new Promise((resolve) => {
  //   resolve({
  //     ...data,
  //     information: { ...data.information, project_expectation_text: data.project_expectation_text },
  //     project_expectation_text: data.project_expectation_text.text,
  //   });
  // })),

  sendBotResponse(),
];
